import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RichTextEditorComponent } from './richtexteditor.component';
/**
 * NgModule definition for the RichTextEditor component.
 */
export class RichTextEditorModule { static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
    imports: [CommonModule],
    declarations: [
        RichTextEditorComponent
    ],
    exports: [
        RichTextEditorComponent
    ]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function RichTextEditorModule_tsickle_Closure_declarations() {
/** @type {?} */
RichTextEditorModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
RichTextEditorModule.ctorParameters;
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
